import {
  FETCH_USER_BALANCES,
  FETCH_USER_BALANCES_FAILED,
  FETCH_USER_BALANCES_SUCCEED,
  UPDATE_USER_INFO,
  UPDATE_USER_INFO_SUCCEED,
  UPDATE_USER_INFO_FAILED,
  FETCH_USER_INFO,
  FETCH_USER_INFO_SUCCEED,
  FETCH_USER_INFO_FAILED,
  GET_USER_LOGIN_HISTORY,
} from './action_types';

export default {
  fetchUserBalancesAction: (data) => ({
    type: FETCH_USER_BALANCES,
    params: {
      data,
    },
  }),
  fetchUserBalancesSucceedAction: (data) => ({
    type: FETCH_USER_BALANCES_SUCCEED,
    params: {
      data,
    },
  }),
  fetchUserBalancesFailedAction: (data) => ({
    type: FETCH_USER_BALANCES_FAILED,
    params: {
      data,
    },
  }),
  updateUserInfoAction: (data) => ({
    type: UPDATE_USER_INFO,
    params: {
      data,
    },
  }),
  updateUserInfoSucceedAction: (data) => ({
    type: UPDATE_USER_INFO_SUCCEED,
    params: {
      data,
    },
  }),
  updateUserInfoFailedAction: (data) => ({
    type: UPDATE_USER_INFO_FAILED,
    params: {
      data,
    },
  }),
  fetchUserInfoAction: () => ({
    type: FETCH_USER_INFO,
  }),
  fetchUserInfoSucceedAction: (data) => ({
    type: FETCH_USER_INFO_SUCCEED,
    params: {
      data,
    },
  }),
  fetchUserInfoFailedAction: (data) => ({
    type: FETCH_USER_INFO_FAILED,
    params: {
      data,
    },
  }),
  getUSerLoginHistory: (data, callback) => ({
    type: GET_USER_LOGIN_HISTORY,
    params: {
      data,
    },
    callback,
  }),
};
